import {
  prefetchCustomerBusinessDetailsRetrieveQuery,
  prefetchCustomerCompanyRetrieveQuery,
  prefetchCustomerPartialBusinessDetailsRetrieveQuery,
  useCustomerBusinessDetailsRetrieve,
  useCustomerCompanyRetrieve,
  useCustomerPartialBusinessDetailsRetrieve,
} from "@boundless/bl-api-client/customer/services"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { useStore } from "zustand"

import { BusinessDetailsForm } from "@/components/business-details/BusinessDetailsForm"
import { PendingComponent } from "@/components/error/PendingComponent"
import { store } from "@/lib/store"

export const Route = createFileRoute("/_dashboard/company/details")({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["customer.view_businessdetails"])) {
      throw redirect({ to: "/" })
    }
  },
  loader: async ({ context: { queryClient, store } }) => {
    const activeCompanyUuid = store.getState().activeCompanyUuid
    if (activeCompanyUuid) {
      prefetchCustomerCompanyRetrieveQuery(queryClient, activeCompanyUuid)
      prefetchCustomerBusinessDetailsRetrieveQuery(
        queryClient,
        activeCompanyUuid,
      )
      prefetchCustomerPartialBusinessDetailsRetrieveQuery(
        queryClient,
        activeCompanyUuid,
      )
    }
  },
})

function RouteComponent() {
  const companyUuid = useStore(store, (state) => state.activeCompanyUuid)

  const { data: company, isLoading: isCompanyLoading } =
    useCustomerCompanyRetrieve(companyUuid ?? "", {
      query: { enabled: !!companyUuid, refetchOnWindowFocus: false },
    })
  const { data: businessDetails, isLoading: isDetailsLoading } =
    useCustomerBusinessDetailsRetrieve(companyUuid ?? "", {
      query: { enabled: !!companyUuid, refetchOnWindowFocus: false },
    })
  const { data: partialBusinessDetails, isLoading: isPartialLoading } =
    useCustomerPartialBusinessDetailsRetrieve(companyUuid ?? "", {
      query: { enabled: !!companyUuid, refetchOnWindowFocus: false },
    })

  if (isCompanyLoading || isDetailsLoading || isPartialLoading) {
    return <PendingComponent />
  }

  return (
    <div className="@container">
      <div className="grid grid-cols-1 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <BusinessDetailsForm
            company={company || null}
            businessDetails={businessDetails || null}
            partialBusinessDetails={partialBusinessDetails || null}
          />
        </div>
      </div>
    </div>
  )
}
